import { Component, ViewChild, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';

import { CalendarTooltipService, TooltipInformation } from './../services/calendar-tooltip.service';

@Component({
  selector: 'cal-tooltip',
  templateUrl: './calendar-tooltip.component.html',
  styleUrls: ['./calendar-tooltip.component.css']
})
export class CalendarTooltipComponent {
  @ViewChild('calendarTooltip') calendarTooltip;
  data: TooltipInformation[] = [];
  bodyRect: any;
  private sub$: Subscription;
  constructor(
    private calendarTooltipService: CalendarTooltipService,
    private renderer: Renderer2
    ) {}

  ngOnInit() {
    this.bodyRect = document.body.getBoundingClientRect();

    this.sub$ = this.calendarTooltipService.toogleTooltip$()
      .subscribe(response => {
        if (response.show === null) return;

        if (response.show) {
          this.data = response.tooltipInformation.map(item => {
            item.end = item.end.replace(/\s/g, "T");
            item.start = item.start.replace(/\s/g, "T");
            item.created = item.created.replace(/\s/g, "T");
            return item;
          });
          this.show(response.event)
        } else {
          this.hide();
        }
      });
  }

  private show(event:MouseEvent) {
    const tooltipOffset = this.calcOffset(event);
    this.renderer.setStyle(this.calendarTooltip.nativeElement, "top", tooltipOffset.y);
    this.renderer.setStyle(this.calendarTooltip.nativeElement, "left", tooltipOffset.x);
    this.renderer.setStyle(this.calendarTooltip.nativeElement, "visibility", "visible");
    this.renderer.setStyle(this.calendarTooltip.nativeElement, "z-index", 9999999);
  }

  private hide() {
    this.renderer.setStyle(this.calendarTooltip.nativeElement, "visibility", "hidden");
    this.renderer.setStyle(this.calendarTooltip.nativeElement, "z-index", 0);
    this.data = [];
  }

  private calcOffset(event: MouseEvent): {x, y} {
    const eventTarget = event.target as HTMLElement;
    const numOfReservations = this.data.length;
    let offsetY = event.pageY - event.offsetY - eventTarget.offsetHeight - (80 * numOfReservations);
    let offsetX = event.screenX - event.offsetX;
    return {
      x: offsetX + 'px',
      y: offsetY + 'px'
    }
  }

  ngOnDestroy() {
    this.sub$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/calendar-tooltip/calendar-tooltip.component.ts